import { Step } from "app/lib/pipeline";
import { GroupStepListItem } from "./GroupStepListItem";
import { CommandStepListItem } from "./CommandStepListItem";
import { StepListItem } from "./StepListItem";
import { WaitStepListItem } from "./WaitStepListItem";
import { TriggerStepListItem } from "./TriggerStepListItem";
import { InputStepListItem } from "./InputStepListItem";

export function createStepListItem({ step }: { step: Step }) {
  switch (step.type) {
    case "group":
      return <GroupStepListItem step={step} key={step.uuid} />;
    case "command":
      return <CommandStepListItem step={step} key={step.uuid} />;
    case "block":
    case "input":
      return <InputStepListItem step={step} key={step.uuid} />;
    case "trigger":
      return <TriggerStepListItem step={step} key={step.uuid} />;
    case "wait":
      return <WaitStepListItem step={step} key={step.uuid} />;
    default:
      return <StepListItem step={step} key={step.uuid} />;
  }
}
